import React from 'react';
import { Box, Container, Typography } from '@mui/material';

/**
 * Section wrapper with optional title, subtitle, and dark variant.
 * Use theme typography variants for titles.
 */
export function Section({
  children,
  title,
  titleVariant = 'h2',
  subtitle,
  id,
  dark = false,
  noContainer = false,
  ...boxProps
}) {
  const content = (
    <>
      {(title || subtitle) && (
        <Box sx={{ mb: 4, textAlign: dark ? 'center' : 'left' }}>
          {title && (
            <Typography
              variant={titleVariant}
              sx={{
                color: dark ? 'primary.contrastText' : 'primary.main',
                fontWeight: 700,
                letterSpacing: '-0.02em',
                gutterBottom: true,
              }}
              gutterBottom
            >
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography
              variant="body1"
              sx={{
                color: dark ? 'rgba(255,255,255,0.85)' : 'text.secondary',
                maxWidth: { xs: '100%', md: '100%' },
                mx: dark ? 'auto' : 0,
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
      {children}
    </>
  );

  return (
    <Box
      id={id}
      component="section"
      sx={{
        py: { xs: 5, md: 7 },
        ...(dark && {
          bgcolor: 'primary.dark',
          color: 'primary.contrastText',
        }),
      }}
      {...boxProps}
    >
      {noContainer ? content : <Container maxWidth="lg">{content}</Container>}
    </Box>
  );
}

export default Section;
